import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Offer } from '../_models/offer';

@Injectable({ providedIn: 'root' })
export class PageService {
    constructor(
        private router: Router,
        private http: HttpClient
    ) {}

    single(slug: any): any {
    	return this.http.get(`${environment.apibase}page/${slug}`);
    }
}